import LenderPageTemplate from '@/components/shared/LenderPageTemplate'

const VolkswagenFinancePage = () => {
  return (
    <LenderPageTemplate
      lenderName="Volkswagen"
      slug="/lenders/mis-sold-volkswagen-car-finance"
      seoImage=""
      seoImageAlt=""
      aiOverview=""
    />
  )
}

export default VolkswagenFinancePage
